import Axios from 'axios';

// Get CSRFToken for header in API call to db
Axios.defaults.xsrfCookieName = 'csrftoken';
Axios.defaults.xsrfHeaderName = 'X-CSRFToken';

// API call to divesite that returns BulkPurchasePackages
export function fetchPackages(url, callback) {
  Axios({ method: 'GET', url }).then(({ data }) => callback(data));
}

export function createBulkPurchaseCode(url, payload) {
  return Axios({ method: 'post', url, data: payload });
}
